import { Avatar, HoverCard, Stack, Text } from '@mantine/core';

function getInitials(name?: string | null, email?: string | null): string {
  if (name) {
    const parts = name.trim().split(/\s+/);
    if (parts.length >= 2)
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    return name.slice(0, 2).toUpperCase();
  }
  if (email) return email.slice(0, 2).toUpperCase();
  return '?';
}

export function UserAvatar(props: {
  name?: string | null;
  email?: string | null;
  picture?: string | null;
  size?: number;
  tooltipExtra?: string;
  onClick?: () => void;
}) {
  const { name, email, picture, size = 28, tooltipExtra, onClick } = props;
  const displayName = name || email;

  return (
    <HoverCard position="top" withArrow shadow="md" openDelay={100}>
      <HoverCard.Target>
        <Avatar
          src={picture}
          size={size}
          radius="xl"
          color="initials"
          name={displayName ?? undefined}
          style={onClick ? { cursor: 'pointer' } : undefined}
          onClick={onClick}
        >
          {!picture && getInitials(name, email)}
        </Avatar>
      </HoverCard.Target>
      <HoverCard.Dropdown p="xs">
        <Stack gap={0}>
          {name && (
            <Text size="xs" fw={500}>
              {name}
            </Text>
          )}
          {email && (
            <Text size="xs" c="dimmed">
              {email}
            </Text>
          )}
          {tooltipExtra && (
            <Text size="xs" c="red">
              {tooltipExtra}
            </Text>
          )}
        </Stack>
      </HoverCard.Dropdown>
    </HoverCard>
  );
}
